// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"_2RneoXg","h5Text":"_3Co9fHu","h4Text":"_2qQ-8kw","h3Text":"SqF-meo","srOnly":"_1zjpy1D","link":"_2BTBfoQ _2RneoXg","container":"_1MMuO3r","list":"q0MjRbt"};